import React, { useState } from 'react';

import { GovBrAccordion, GovBrTable } from 'components';
import { simpleDateFormat } from 'utils/dateFunctions';
import '../ReprocessingPage.css';
import { useNewConsentModalContext } from 'pages/SharePage/Context/NewConsentModalContext';
import { DateField } from './DateField';

export function ReprocessingAccordion({ data }) {
  const { organizationList } = useNewConsentModalContext();
  const [filterDate, setFilterDate] = useState('');

  const dictStatus = {
    created: 'Criado',
    completed: 'Concluído',
    'entered-in-error': 'Cancelado',
    started: 'Iniciado',
    updated: 'Atualizado',
  };

  const header = [
    { display: 'CPF ou CNS', path: 'patientId' },
    { display: 'ID do documento', path: 'documentId' },
    { display: 'Tipo do documento', path: 'documentType' },
    { display: 'Unidade hospitalar', path: 'organization' },
    {
      display: <DateField setFilterDate={setFilterDate} />,
      path: 'startDate',
    },
    { display: 'Data de término', path: 'endDate' },
    { display: 'Status', path: 'status' },
  ];

  let filteredRows = data.map((el) => ({
    ...el,
    startDate: simpleDateFormat(el.startDate),
    endDate: simpleDateFormat(el.endDate),
    organization:
      organizationList?.find(
        (e) => e.resource.identifier[0].value === el.organization,
      )?.resource?.alias || 'Não definido',
    status: dictStatus[el.status],
  }));

  if (filterDate) {
    filteredRows = filteredRows?.filter(
      (el) => el.startDate === simpleDateFormat(filterDate),
    );
  }

  const accordion = {
    title: 'Monitoramento de reprocessamento',
    content: <GovBrTable header={header} body={filteredRows} />,
  };

  return (
    <GovBrAccordion
      name={accordion.title}
      content={accordion.content}
      total={filteredRows?.length}
      defaultOpen
    />
  );
}
